import { Card } from '@chakra-ui/react';
import { FunctionComponent as FC } from 'react';
import { MCard, MFlex, MText } from '../../Monetize';

interface QuoteAnalyticsInfoCardProps {
  text: string | string[];
}

export const QuoteAnalyticsInfoCard: FC<QuoteAnalyticsInfoCardProps> = ({
  text,
}: QuoteAnalyticsInfoCardProps) => {
  const paragraphs = Array.isArray(text) ? text : [text];

  return (
    <MCard variant="borderless" mt="2">
      <Card.Body px="2" py="1">
        <MFlex flexDirection="column" gap="1">
          {paragraphs.map((paragraph, index) => (
            <MText
              key={index}
              fontSize="sm"
              fontStyle="italic"
              color="tGray.darkPurple"
            >
              {paragraph}
            </MText>
          ))}
        </MFlex>
      </Card.Body>
    </MCard>
  );
};
